import PropTypes from 'prop-types'

import { AdasAvatar } from '@components/wrapper-components'

const initials = (name) => {
  if (name) {
    return name.split(' ').reduce((accumulator, currentValue) => accumulator + currentValue[0].toUpperCase(), '')
  }

  return '?'
}

export const CaradasAvatar = ({ user, size }) => {
  return (
    <AdasAvatar className={`bg-primary ${size === 'sm' ? 'w-6 h-6 text-xs' : 'w-10 h-10 text-base'}`}>
      {user?.name && initials(user?.name).slice(0, 2)}
    </AdasAvatar>
  )
}

CaradasAvatar.propTypes = { user: PropTypes.object, size: PropTypes.string }
